import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import type { CmsExternalServiceLink } from '@gov-nx/api';
import type { Nullable } from '@gov-nx/core/types';
import type { RepresentationFormType } from './FormDefinition';
import { useRepresentationForm } from './FormDefinition';

interface SmartFormContextTypes extends RepresentationFormType {
	link: CmsExternalServiceLink;
}

const Context = createContext<Nullable<SmartFormContextTypes>>(null);

export function SmartFormContextProvider({
	children,
	link,
	nazev,
}: PropsWithChildren<{ link: CmsExternalServiceLink; nazev?: string }>) {
	const representationForm = useRepresentationForm({ link: link.link, nazev });

	return (
		<Context.Provider
			value={{
				link,
				...representationForm,
			}}>
			{children}
		</Context.Provider>
	);
}

export const useSmartFormContext = (): SmartFormContextTypes =>
	useContext(Context) as SmartFormContextTypes;
